import styled from 'styled-components'

import { NumberUtil } from '@root/shared'
import { Input } from '@root/shared/ui-kit'

import { TradingSlider } from '../common/trading-slider'

import type { TradeType } from '@root/entities/trade-type'

type Props = {
  type: TradeType.SwapDirection
  percentage: number
  onPercentageChange: (percentage: number) => void
}

export const TradingControlsLimitPercentage: React.FC<Props> = ({
  type,
  percentage,
  onPercentageChange,
}) => {
  return (
    <Percentage>
      <TradingSlider
        type={type}
        value={percentage}
        onChange={([value]) => onPercentageChange(value ?? 0)}
        ticks={[-100, -50, 0, 50, 100]}
        step={1}
      />

      <Input
        numeric
        value={percentage}
        onInput={(e) => {
          const value = NumberUtil.parseBigNumber(
            e.currentTarget.value,
          )?.toNumber()

          if (value !== undefined) {
            onPercentageChange(value)
          }
        }}
        allowNegative
        size="m"
        placeholder="0"
        endContent={<CharIcon>%</CharIcon>}
      />
    </Percentage>
  )
}

const CharIcon = styled.div`
  color: var(--text-11);
  text-align: right;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
`

const Percentage = styled.div`
  display: grid;
  grid-template-columns: 3fr 80px;
  gap: 15px;
`
